import { useState } from 'react'
import { ChevronRightIcon } from '@heroicons/react/24/outline'

export default function MythVsFact({ myths = [] }) {
  const [flippedCards, setFlippedCards] = useState(new Set())

  const toggleCard = (id) => {
    const newFlipped = new Set(flippedCards)
    if (newFlipped.has(id)) {
      newFlipped.delete(id)
    } else {
      newFlipped.add(id)
    }
    setFlippedCards(newFlipped)
  }

  const handleKeyPress = (event, id) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      toggleCard(id)
    }
  }

  return (
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-center mb-12">Myths vs Facts</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {myths.map((item) => {
            const isFlipped = flippedCards.has(item.id)
            return (
              <div
                key={item.id}
                className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer transform transition-transform hover:scale-105 focus-within:scale-105"
                onClick={() => toggleCard(item.id)}
                onKeyDown={(e) => handleKeyPress(e, item.id)}
                tabIndex={0}
                role="button"
                aria-expanded={isFlipped}
                aria-label={`Myth vs fact card: ${isFlipped ? 'showing fact' : 'showing myth'}`}
              >
                <div className="p-6 min-h-[200px] flex flex-col">
                  {item.image && (
                    <img 
                      src={item.image} 
                      alt="Historical illustration" 
                      className="w-full h-32 object-cover object-top rounded mb-4"
                      style={{boxShadow: '0 4px 12px rgba(0,0,0,0.12)'}}
                    />
                  )}
                  {!isFlipped ? (
                    <>
                      <div className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-semibold mb-4 self-start">
                        MYTH
                      </div>
                      <p className="text-lg flex-grow">{item.myth}</p>
                      <div className="flex items-center justify-end mt-4 text-primary-600">
                        <span className="text-sm font-medium">Click to reveal fact</span>
                        <ChevronRightIcon className="w-4 h-4 ml-1" aria-hidden="true" />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-semibold mb-4 self-start">
                        FACT
                      </div>
                      <p className="text-lg flex-grow mb-4 whitespace-pre-line">{item.fact}</p>
                      {item.source && (
                        <p className="text-sm text-neutral-600 italic">
                          Source: {item.source}
                        </p>
                      )}
                    </>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}